import { isScheduleActivity } from "@/features/calendar/utils";
import { type Appointment, type Task, isTask } from "@repo/api";

import { isAppointment } from "../../appointments/utils";
import { type CoWorkerScheduleActivity, type OutlookEvent } from "../types";
import { isOutlookEvent } from "../useUserCalendar";

const MAX_DATE = new Date(8640000000000000);

export const sortCalendarItems = (
  a: Appointment | Task | OutlookEvent | CoWorkerScheduleActivity,
  b: Appointment | Task | OutlookEvent | CoWorkerScheduleActivity
) => {
  let leftTime = new Date();
  let rightTime = new Date();
  let leftEndTime = new Date();
  let rightEndTime = new Date();
  let leftId = "";
  let rightId = "";

  if (isAppointment(a)) {
    leftTime = new Date(a.timeWindowStartTime);
    leftEndTime = new Date(a.timeWindowEndTime);
    leftId = String(a.id);
  } else if (isOutlookEvent(a)) {
    leftTime = new Date(`${a.start.dateTime}+00:00`);
    leftEndTime = new Date(`${a.end.dateTime}+00:00`);
    leftId = String(a.id);
  } else if (isTask(a)) {
    leftTime = a.taskStartDateTime ? new Date(a.taskStartDateTime) : MAX_DATE;
    leftEndTime = a.taskEndDateTime ? new Date(a.taskEndDateTime) : MAX_DATE;
    leftId = String(a.id);
  } else if (isScheduleActivity(a)) {
    leftTime = a.start;
    leftEndTime = a.end;
    leftId = a.id;
  }

  if (isAppointment(b)) {
    rightTime = new Date(b.timeWindowStartTime);
    rightEndTime = new Date(b.timeWindowEndTime);
    rightId = String(b.id);
  } else if (isOutlookEvent(b)) {
    rightTime = new Date(`${b.start.dateTime}+00:00`);
    rightEndTime = new Date(`${b.end.dateTime}+00:00`);
    rightId = String(b.id);
  } else if (isTask(b)) {
    rightTime = b.taskStartDateTime ? new Date(b.taskStartDateTime) : MAX_DATE;
    rightEndTime = b.taskEndDateTime ? new Date(b.taskEndDateTime) : MAX_DATE;
    rightId = String(b.id);
  } else if (isScheduleActivity(b)) {
    rightTime = b.start;
    rightEndTime = b.end;
    rightId = b.id;
  }

  // Compare start times
  const startTimeDiff = leftTime.getTime() - rightTime.getTime();
  if (startTimeDiff !== 0) {
    return startTimeDiff;
  }

  // If start times are equal, compare end times
  const endTimeDiff = leftEndTime.getTime() - rightEndTime.getTime();
  if (endTimeDiff !== 0) {
    return endTimeDiff;
  }

  // If both start and end times are equal, compare by id
  return String(leftId).localeCompare(String(rightId));
};
